import React, { useContext, useState } from "react";
import CustomTypography from "../../../ui/widgets/typography";
import { useMessageSource } from "react-message-source";
import GridItem from "../../../ui/layout/page/grid-item";
import RadioButton from "../../../ui/widgets/radiobutton";
import { RadioButtonItem } from "../../../ui/widgets/radiobutton/types";
import { ProductContext } from "../../../context/product-context/productContext";
import CreditCardIcon from "../../../resources/images/scd-credit-card-icon.svg";
import { DashboardContext } from "../context";
import Dropdown from "../../../ui/widgets/dropdown";
import { useMediaQuery } from "@mui/material";
import { breakpointValues } from "../../../theme/theme";
import { DropdownMenuItemProps } from "../../../ui/widgets/dropdown/types";
import { ProductFamily } from "../../../context/product-context/product-family";

const classBaseName = "product-family-filter";
const largeScreens = `only screen and (min-width: ${breakpointValues.md}px)`;

interface ProductFamilyFilterProps {
  changeProductFamily: (changedFamily: ProductFamily) => void;
}

const ProductFamilyFilter: React.FC<ProductFamilyFilterProps> = ({
  changeProductFamily,
}: ProductFamilyFilterProps): React.JSX.Element => {
  const { selectedProduct, findFamilyFromAll } = useContext(ProductContext);
  const { getMessage } = useMessageSource();
  const [selectedProductFamily, setSelectedProductFamily] =
    useState<ProductFamily>(() => {
      return selectedProduct?.family;
    });
  const { appliedFamilies } = useContext(DashboardContext);

  const isCurrentScreenLarge = useMediaQuery(largeScreens);

  const renderProductFamilyRadioGroup = () => {
    const radioButtonOptions: RadioButtonItem[] = [];
    appliedFamilies.forEach((family: ProductFamily) => {
      radioButtonOptions.push({
        id: family.name,
        label: getMessage(`${family.translationKey}.title`),
        value: family.name,
        icon: CreditCardIcon,
      } as RadioButtonItem);
    });

    return (
      <RadioButton
        selectedValue={selectedProductFamily.name}
        id="id"
        fullStretch
        name="product-family-filter"
        onClick={(val) => {
          const foundFamily = findFamilyFromAll(
            val.value as ProductFamily["name"],
          );
          changeProductFamily(foundFamily);
          setSelectedProductFamily(foundFamily);
        }}
        values={radioButtonOptions}
      />
    );
  };

  const renderProductFamilyDropdown = () => {
    const dropdownOptions: DropdownMenuItemProps[] = [];
    appliedFamilies.forEach((family: ProductFamily) => {
      dropdownOptions.push({
        value: family.name,
        children: getMessage(`${family.translationKey}.title`),
      });
    });

    return (
      <Dropdown
        menuItems={dropdownOptions}
        selectedItemValue={selectedProductFamily.name}
        onSelect={(e) => {
          const foundFamily = findFamilyFromAll(
            e.target.value as ProductFamily["name"],
          );
          changeProductFamily(foundFamily);
          setSelectedProductFamily(foundFamily);
        }}
      />
    );
  };

  return (
    <div className={classBaseName}>
      <div className="scd-section-helper-lg">
        <CustomTypography variant="h4">
          {getMessage("Dashboard.product-family.title")}
        </CustomTypography>
      </div>
      <GridItem>
        {isCurrentScreenLarge
          ? renderProductFamilyRadioGroup()
          : renderProductFamilyDropdown()}
      </GridItem>
    </div>
  );
};

export default ProductFamilyFilter;
